import { CheckoutState } from '../../state';
import { WithSurveyNamespace } from '../../state/survey';
import { getNamespaceValue } from '../utils/selector';

export const getQuestionsCollection = (state: WithSurveyNamespace) =>
    getNamespaceValue(state.survey, 'questionsCollection');

export const getInteractiveQuestionsByAttendeeId = (
    state: WithSurveyNamespace,
) => getNamespaceValue(state.survey, 'interactiveQuestionsByAttendeeId');

export const getBillingZipCode = (state: CheckoutState) => {
    const userInstruments = getNamespaceValue(
        state.user,
        'userInstruments',
        [],
    );

    const {
        form: { checkoutForm: { values: { payment = {} } = {} } = {} },
    } = state;

    const cardPostalCode = payment.cardPostalCode;

    if (cardPostalCode) {
        return cardPostalCode;
    }

    const vaultId =
        'vaultId' in payment ? (payment as { vaultId?: string }).vaultId : null;

    if (vaultId) {
        const selectedInstrument = userInstruments.find(
            (instrument) => instrument.vaultId === vaultId,
        );

        if (selectedInstrument) {
            return selectedInstrument.billingInformation.address.postalCode;
        }
    }

    return '';
};

export const getFirstAttendeeWithSurvey = (state: CheckoutState) => {
    const attendees = getNamespaceValue(state.order, 'attendees', []);

    return attendees.find(
        (attendee) => attendee.survey && attendee.survey.length,
    );
};

export const getSurveyResponsesByAttendeeId = (state: CheckoutState) =>
    state.survey?.surveyResponsesByAttendeeId;
